import React from 'react';
import AvailableAppraiserList from './AvailableAppraiserList';

/**
 * @typedef {object} AvailableAppraisersInfoBoxAvailableAppraisers
 * @property {Array<*>} [Atls]
 * @property {Array<*>} [AtlCandidates]
 * @property {Array<*>} [Atms]
 * @property {Array<*>} [AtmCandidates]
 */

/**
 * @typedef {object} AvailableAppraisersInfoBoxProps
 * @property {AvailableAppraisersInfoBoxAvailableAppraisers} [availableAppraisers]
 */

/**
 * @param {AvailableAppraisersInfoBoxProps} props
 */
const AvailableAppraisersInfoBox = props => {
  const { availableAppraisers } = props;

  return (
    <div className='appraisers-info' data-testid='appraisers-info'>
      <div>
        <AvailableAppraiserList title='ATLs Available' appraisers={availableAppraisers.Atls} />
        <AvailableAppraiserList
          title='ATL Candidates'
          appraisers={availableAppraisers.AtlCandidates}
        />
        <AvailableAppraiserList title='ATMs Available' appraisers={availableAppraisers.Atms} />
        <AvailableAppraiserList
          title='ATM Candidates'
          appraisers={availableAppraisers.AtmCandidates}
        />
      </div>
    </div>
  );
};

export default AvailableAppraisersInfoBox;
